import Vue from 'vue'
import {Table, TableColumn, Select, Option} from 'element-ui'
import PPagination from '@/components/UIComponents/Pagination'
import Moment from 'moment'
import API from '@/services/API'
import Armazenamento from '@/services/Armazenamento'
import Assinatura from '@/services/Assinatura'
import {Collapse, CollapseItem} from 'element-ui'
import Swal from 'sweetalert2'


Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(Collapse)
Vue.use(CollapseItem)
var self
const controller = {
  name: 'SimulacoesListaCtrl',
  components: {
    PPagination
  },
  computed: {
    pagedData () {
      return this.tableData.slice(this.from, this.to)
    },
    queriedData () {
      if (!this.searchQuery && !this.tipoSimulacao && !this.tipoProjeto && !this.dateFrom && !this.dateTo) {
        this.pagination.total = this.tableData.length
        return this.pagedData
      }
      let result = this.tableData
        .filter((row) => {
          console.log(row);
          let isIncluded = false
          let tipoProjetoSelecionado = false;
          let tipoSimulacaoSelecionado = false;
          let dataInicialSelecionado = false;
          let dataFinalSelecionado = false;
          let buscaSelecionada = false;
          let rowValue = row.simulacao_entrada.dados.nome;
          if (String(rowValue).length > 0) {
            if (String(rowValue).toUpperCase().includes(this.searchQuery.toUpperCase())) {
              buscaSelecionada = true
            } else {
              buscaSelecionada = false
            }
          } else {
            buscaSelecionada = true
          }
          rowValue = row.tipoProjeto;
          if (this.tipoProjeto.length > 0) {
            tipoProjetoSelecionado = true
            if (String(rowValue).toUpperCase().includes(this.tipoProjeto.toUpperCase())) {
              tipoProjetoSelecionado = true
            } else {
              tipoProjetoSelecionado = false
            }
          } else {
            tipoProjetoSelecionado = true
          }
          rowValue = row.tipoSimulacao;
          if (this.tipoSimulacao.length > 0) {
            if (String(rowValue).toUpperCase().includes(this.tipoSimulacao.toUpperCase())) {
              tipoSimulacaoSelecionado = true
            } else {
              tipoSimulacaoSelecionado = false
            }
          } else {
            tipoSimulacaoSelecionado = true
          }
          rowValue = Moment(row.criado_em, 'DD/MM/YYYY').toDate();
          if (String(this.dateFrom).length > 0) {
            if (rowValue >= Moment(this.dateFrom, 'DD/MM/YYYY').toDate()) {
              dataInicialSelecionado = true
            } else {
              dataInicialSelecionado = false
            }
          } else {
            dataInicialSelecionado = true
          }
          if (String(this.dateTo).length > 0) {
            if (rowValue <= Moment(this.dateTo, 'DD/MM/YYYY').toDate()) {
              dataFinalSelecionado = true
            } else {
              dataFinalSelecionado = false
            }
          } else {
            dataFinalSelecionado = true
          }
          if (tipoProjetoSelecionado && tipoSimulacaoSelecionado && buscaSelecionada && dataInicialSelecionado && dataFinalSelecionado) {
            isIncluded = true
          }
          return isIncluded
        })
      this.pagination.total = result.length
      return result.slice(this.from, this.to)
    },
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      this.pagination.total = this.tableData.length
      return this.tableData.length
    }
  },
  data () {
    return {
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      dateFrom: '',
      dateTo: '',
      projetoOpcoes: [{
        value: 'Confinamento',
        label: 'Confinamento'
      }, {
        value: 'Pasto',
        label: 'Pasto'
      }],
      tipoProjeto: '',
      simulacaoOpcoes: [{
        value: 'Básico',
        label: 'Básico'
      }, {
        value: 'Avançado',
        label: 'Avançado'
      }],
      tipoSimulacao: '',
      propsToSearch: ['Tipo de Projeto', 'Tipo de Simulação', 'Estágio do Negócio', 'Nome da Simulação', 'Data da Simulação', 'Data D1'],
      tableColumns: [
        {
          prop: 'tipoProjeto',
          label: 'Tipo de Projeto',
          minWidth: 90
        },
        {
          prop: 'tipoSimulacao',
          label: 'Tipo de Simulação',
          minWidth: 90
        },
        {
          prop: 'estagioNegocio',
          label: 'Estágio do Negócio',
          minWidth: 90
        },
        {
          prop: 'simulacao_entrada.dados.nome',
          label: 'Nome da Simulação',
          minWidth: 120
        },
        {
          prop: 'criado_em',
          label: 'Data da Simulação',
          minWidth: 85
        },
        {
          prop: 'dataD1',
          label: 'Data D1',
          minWidth: 60
        }
      ],
      tableData: []
    }
  },
  methods: {
    ir (name, id) {
      this.$router.push({
        name,
        params: {
          id
        }
      })
    },
    pegaOpcao (simulacao, tipo) {
      if (simulacao === 'Básico') {
        return tipo === 'Pasto' ? 'pasto-basico-ver' : 'confinamento-basico-ver'
      } else {
        return tipo === 'Pasto' ? 'pasto-avancado-ver' : 'confinamento-avancado-ver'
      }
    },
    handleEdit (index, row) {
      this.ir(this.pegaOpcao(row.tipoSimulacao, row.tipoProjeto), row.id)
    },
    handleRemove (index, row) {
      Swal({
        title: 'Tem certeza de que deseja remover sua simulação ?',
        text: "Sua simulação será arquivada.",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar'
      }).then(function(isConfirm) {
        if (isConfirm) {
          API.simulacao.remover(row.id)
          .then(response => {
            API.simulacao.listar()
            .then(response => {
              if (response.status === 200) {
                self.tableData = response.data.simulacoes;
                Armazenamento.quantidadeSimulacoes.gravar({ quantidade: self.tableData.length })
                Assinatura.buscar()
              }
            })
            .catch(err => {
              console.log("Error:")
              console.log(err)
            })
            Swal(
              'Removido!',
              'Sua simulação foi removida.',
              'success'
            );
          })
          .catch(err => {
            console.log("Error:")
            console.log(err)
            Swal(
              'Oops...',
              'Erro ao remover simulação.',
              'error'
            );
          })
        }
      }).catch(err => {
        // console.log("Error:")
        // console.log(err)
      })
    }
  },
  created () {
    API.simulacao.listar()
      .then(response => {
        if (response.status === 200) {
          this.tableData = response.data.simulacoes;
          Armazenamento.quantidadeSimulacoes.gravar({ quantidade: this.tableData.length })
          Assinatura.buscar()
          self = this
        }
      })
      .catch(err => {
        console.log(err)
      })
  }
}

export default controller



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Simulacoes/ListaCtrl.js